import { ignoreBrowserExtensionRuntimeErrors } from './ignoreBrowserExtensionRuntimeErrors';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from 'redux/store';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@mui/material';
import theme from './theme/theme';

ignoreBrowserExtensionRuntimeErrors();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <ThemeProvider theme={theme}>
                <ToastContainer />
                <App />
            </ThemeProvider>
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in the app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
